import { ApplicationShell, OpenHandler, WidgetManager } from '@theia/core/lib/browser';
import { inject, injectable } from '@theia/core/shared/inversify';
import URI from '@theia/core/lib/common/uri';
import { ImagePreviewOptions, ImagePreviewWidget, MIME_TYPES } from './image-preview-widget';

@injectable()
/**
 * OpenHandler for image files. It provides a way to preview images in the Theia IDE.
 */
export class ImageOpenHandler implements OpenHandler {
    readonly id: string = 'image-preview-handler';
    readonly label: string = 'Image Preview';

    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    @inject(ApplicationShell)
    protected readonly shell!: ApplicationShell;

    canHandle(uri: URI): number {
        return uri.path.ext.toLowerCase() in MIME_TYPES ? 500 : 0;
    }

    async open(uri: URI): Promise<ImagePreviewWidget> {
        const options: ImagePreviewOptions = { uri: uri.toString() };
        const widget: ImagePreviewWidget = await this.widgetManager.getOrCreateWidget<ImagePreviewWidget>(
            ImagePreviewWidget.ID,
            options
        );
        if (!widget.isAttached) await this.shell.addWidget(widget, { area: 'main' });
        await this.shell.activateWidget(widget.id);
        return widget;
    }
}
